import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  if (!ready) {
    return <div className="min-h-[60vh] flex items-center justify-center text-neutral-400">Lade...</div>;
  }
  if (!user || user === false || user.role !== "admin") return <Navigate to="/login" replace />;
  return children;
}
